import HeadComponent from "@js/components/Head";
import { EducationLessonPageProps } from "@js/components/EducationLesson/types";
import EducationLesson from "@js/components/EducationLesson";
import {
    getCourseFromConfig,
    getLessonAndModuleInfoFromConfig,
    getLessonCountFromModule,
    getLessonProgress,
    hasAccessToLesson,
} from "@js/util/educationUtil";
import Breadcrumb from "@js/components/Breadcrumb";
import { getAddressFromHeaders } from "@js/util/cookieUtil";
import { getAllCourseProgress } from "@js/prisma/prisma";

const props: EducationLessonPageProps = {
    courseName: "N/A",
    moduleInfo: {
        title: "N/A",
        description: "N/A",
        id: -1,
    },
    lesson: {
        title: "N/A",
        description: "N/A",
        id: -1,
    },
    isComplete: false,
};

const defaultProps: any = {
    props: props,
};

export async function getServerSideProps(context: any) {
    // resolved url is the requested page (ex. /module/123)
    let path = context.resolvedUrl;
    try {
        // get moduleId and lesson id, can parse int because if they are not numbers we should go to the catch case -> id's should be numbers
        const splitAtModule = path.split("/module/")[1];
        const moduleId = parseInt(splitAtModule.split("/")[0]);
        const lessonId = parseInt(splitAtModule.split("/lesson/")[1]);
        //get courseName, this is a string
        const splitAtCourse = path.split("/course/")[1];
        const courseName = splitAtCourse.split("/")[0];
        //get the  course information to get styling for external courses
        let course = getCourseFromConfig(courseName);
        let buttonStyle = null;
        if (course && course.borderColorStyle) {
            buttonStyle = course.buttonStyle;
        }
        //get the correct module and lesson information
        const { moduleInfo, lesson } = getLessonAndModuleInfoFromConfig(
            courseName,
            moduleId,
            lessonId
        );
        if (!lesson) {
            return defaultProps;
        }

        const numLessons = getLessonCountFromModule(courseName, moduleId);

        const address = getAddressFromHeaders(context.req.headers);
        const allCourseProgress = await getAllCourseProgress(address);
        const hasAccess = hasAccessToLesson(
            allCourseProgress,
            courseName,
            moduleId,
            lessonId,
            numLessons
        );
        const hasNextAccess = hasAccessToLesson(
            allCourseProgress,
            courseName,
            moduleId,
            lessonId + 1,
            numLessons
        );

        const lessonProgress = getLessonProgress(
            allCourseProgress,
            courseName,
            moduleId,
            lessonId
        );
        const savedCode = lessonProgress ? lessonProgress.code : "";
        const isComplete = lessonProgress ? lessonProgress.isComplete : false;

        return {
            props: {
                courseName: courseName,
                moduleInfo: moduleInfo,
                lesson: lesson,
                hasAccess: hasAccess,
                hasNextAccess: hasNextAccess,
                buttonStyle: buttonStyle,
                savedCode,
                isComplete,
            },
        };
    } catch (e) {
        console.error(e);
        return defaultProps;
    }
}

const EducationLessonPage = (props: EducationLessonPageProps) => {
    const moduleTitle = props.moduleInfo.title;
    const lessonTitle = props.lesson.title;
    let educationTitle = `Module: ${moduleTitle}, Lesson: ${lessonTitle}`;

    if (!props.hasAccess) {
        return (
            <>
                <Breadcrumb />
                <div>You do not have access</div>
            </>
        );
    }
    return (
        <>
            <Breadcrumb />
            <HeadComponent title={educationTitle} />
            <EducationLesson {...props} />
        </>
    );
};

export default EducationLessonPage;
